import type { FC } from 'react';
import React from 'react';
import { Aligner } from '@alfa-bank/site-aligner';
import { BackgroundV2 } from '@alfa-bank/site-background-v2';

import type { TGentleErrorPage } from './models';

export const GentleErrorPage: FC<TGentleErrorPage> = ({
    Text,
    config,
    description,
    styles,
    title,
}) => {
    return (
        <Aligner align="center" data-test-id="dc-form-gentle-error-page">
            <Text
                styler={{ margin: 0, paddingLeft: 24, paddingRight: 24 }}
                tag="h2"
                view={config.title.view}
            >
                {title}
            </Text>
            <BackgroundV2
                className={styles.descriptionContainer}
                color="white"
                styler={{ ...config.descriptionContainer }}
            >
                <Text styler={{ margin: 0 }} tag="p" view="primary-medium">
                    {description}
                </Text>
            </BackgroundV2>
        </Aligner>
    );
};
